import { html, nothing } from 'lit';
import { type TefComs } from '@src/components/tef-coms';
import { service } from '@src/service';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '@src/service/tracker';
import { store } from '@src/store';
import { save, cancelPage } from '@src/store/consents';
import { ConsentGroup } from '@src/types/common';

export const cancelButton = html`
<one-button
  variant="plain"
  @click=${

  () => {
    store.dispatch(cancelPage());
    service.tracker.doTracking(
      TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION,
      {},
    );
  }
}
> Abbrechen
</one-button>`;

export const saveButton = (changesMadePage: boolean) => html`
<one-button
    .disabled=${!changesMadePage}
    @click=${
  () => {
    store.dispatch(save());
  }

}
> Speichern
</one-button>`;

export const consentGroupTemplate = (consentGroup: ConsentGroup, idx: number, tefComs: TefComs) => html`
  <tef-coms-consent-group
    .consentGroup=${consentGroup}
    .groupIndex=${idx}
    .mode=${tefComs.mode}
    data-testid="group-${consentGroup.name.toLowerCase()}"></tef-coms-consent-group>`;

export const buttonModeTemplate = (buttonModeButton: string, changesMadePage: boolean) => {
  const buttonActive = changesMadePage || buttonModeButton === 'saveActive';
  const showButton = !buttonModeButton || buttonModeButton.startsWith('save'); // save && saveActive

  return html`
    <one-button-group>
      ${showButton ? saveButton(buttonActive) : nothing}
      <one-spacer size="fill"></one-spacer>
      ${!buttonModeButton ? cancelButton : nothing}
    </one-button-group>`;
};
